/* 🤖 this file was generated by svg-to-ts */
export const mgcIconRightFilled: {
  name: 'right-filled';
  data: string;
} = {
  name: 'right-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.999 4.894c-.4.086-.802.401-.994.776a1.61 1.61 0 0 0-.125.931c.091.503.076.485 2.613 3.029L12.857 12l-2.364 2.37c-2.549 2.555-2.538 2.542-2.618 3.044-.047.292.008.676.131.918.374.732 1.292 1.019 2.051.641.159-.079.85-.748 3.185-3.087 3.431-3.435 3.218-3.177 3.218-3.886s.213-.451-3.218-3.886c-3.187-3.191-3.129-3.139-3.621-3.23-.281-.052-.335-.052-.622.01"/></svg>`
};
